import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Box from "@mui/material/Box";
import HomeIcon from "@mui/icons-material/Home";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";

const TABS = [
  { label: "Главная", value: "/", icon: <HomeIcon /> },
  { label: "Меню", value: "/menu", icon: <RestaurantIcon /> },
  { label: "Акции", value: "/promotions", icon: <LocalOfferIcon /> },
  { label: "Заказы", value: "/orders", icon: <ShoppingCartIcon /> },
];

export const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const currentTab =
    TABS.find(
      (tab) =>
        location.pathname === tab.value ||
        (tab.value !== "/" && location.pathname.startsWith(tab.value))
    )?.value || "/";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <Box sx={{ flex: 1, overflow: "hidden" }}>
        <Outlet />
      </Box>

      <BottomNavigation
        value={currentTab}
        onChange={(event, newValue) => navigate(newValue)}
        sx={{ borderTop: 1, borderColor: "divider" }}
      >
        {TABS.map((tab) => (
          <BottomNavigationAction
            key={tab.value}
            label={tab.label}
            value={tab.value}
            icon={tab.icon}
          />
        ))}
      </BottomNavigation>
    </Box>
  );
};
